import type { ReactElement } from 'react';
import { useUIDSeed } from 'react-uid';
import { FeatureFlag, Route } from 'config';

import SkeletonLine from 'components/shared/skeletons/SkeletonLine';
import { Component as CartIcon } from 'icons/icon-ui--cart.svg';
import { Component as CaretIcon } from 'icons/icon-ui--arrow-right-outline.svg';
import useCurrentUser from '../../../hooks/useCurrentUser';

function NavItemSkeleton({ active, className } : { active: boolean, className: string }) {
  return (
    <li className="c-nav__item nav-item">
      <span className={`${className}${active ? ' active' : ''}`}>
        <SkeletonLine width={80} height={15} />
      </span>
    </li>
  );
}

function Skeleton(): ReactElement {
  const seed = useUIDSeed();

  return (
    <header
      role="banner"
      className={[
        'c-meal-management--skeleton',
        'c-meal-management-sticky',
      ].join(' ')}
    >
      <div className="c-meal-management-header">
        <div className="l-container">
          <div className="c-meal-management-header__container">
            <div>
              <div className="c-meal-management-header__path u-text--sm">
                <a
                  href={Route.UPCOMING_MENUS}
                  className="js-heap-navigate-home-page"
                >
                  Upcoming Deliveries
                </a>
                &nbsp;/&nbsp;
                <SkeletonLine width={140} height={15} />
              </div>
              <div className="c-meal-management-header__title">
                <SkeletonLine width={340} height={21} />
              </div>
            </div>
            <div className="c-meal-management-header__cart">
              <button
                name="button"
                type="button"
                className="c-meal-management-cart-button"
              >
                <CartIcon
                  height="17"
                  className="c-meal-management-cart-button__icon"
                />

                <span className="c-meal-management-cart-button__count" />
                &nbsp;

                <span className="c-meal-management-cart-button__total">
                  Total:&nbsp;
                  <SkeletonLine width={60} height={18} />
                </span>
                &nbsp;

                <span className="c-meal-management-cart-button__arrow">
                  <CaretIcon
                    className="c-meal-management-cart-button__caret"
                  />
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <>
        <div className="c-header__sub">
          <div className="c-tab-container">
            <ul className="c-nav c-nav--tabs">
              {[...Array(4)].map((el, i) => (
                <NavItemSkeleton active={i === 0} key={seed(i)} className="c-nav__link nav-link" />
              ))}
            </ul>
          </div>
        </div>
        <div className="c-header__sub">
          <div className="c-tab-container">
            <ul className="c-nav c-nav--tabs">
              {[...Array(5)].map((el, i) => (
                <NavItemSkeleton active={false} key={seed(i)} className="c-nav__pill nav-link" />
              ))}
            </ul>
          </div>
        </div>
      </>
    </header>
  );
}

export default Skeleton;
